var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({class:[
    'button',
    !_vm.disabled && _vm.variant,
    `size-${_vm.size}`,
    { disabled: _vm.disabled, pressed: _vm.pressed }
  ],attrs:{"disabled":_vm.disabled}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }